export default __webpack_public_path__ + "scene4_1_bg006337.png";